import type { IndexDescription } from "src/db";

const same = (left: string, right: string): boolean => left.toLowerCase() === right.toLowerCase();

export const resolveFieldName = ({
    fields,
    wanted,
}: {
    fields: IndexDescription[];
    wanted: string;
}): string => {
    const exact = fields.find((field) => same(field.name, wanted));
    if (exact) return exact.name;

    const suffix = fields.find((field) => same(field.name.split(".").pop() ?? "", wanted));
    if (suffix) return suffix.name;

    const byHeader = fields.find((field) => same(field.header_name ?? "", wanted));
    return byHeader?.name ?? wanted;
};
